export const WarningIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99984 1.66669C5.39984 1.66669 1.6665 5.40002 1.6665 10C1.6665 14.6 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6 18.3332 10C18.3332 5.40002 14.5998 1.66669 9.99984 1.66669ZM9.99984 10.8334C9.5415 10.8334 9.1665 10.4584 9.1665 10V6.66669C9.1665 6.20835 9.5415 5.83335 9.99984 5.83335C10.4582 5.83335 10.8332 6.20835 10.8332 6.66669V10C10.8332 10.4584 10.4582 10.8334 9.99984 10.8334ZM10.8332 14.1667H9.1665V12.5H10.8332V14.1667Z" />
  </svg>
);
